import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { CalendarComponentOptions } from 'ion2-calendar';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';





@Component({
  selector: 'page-kasiyer-bazli-rapor',
  templateUrl: 'kasiyer-bazli-rapor.html',
})
export class KasiyerBazliRaporPage {
  @ViewChild('sideNavUrunAra') sideNav;
  gelenRapor =[];
  tarih1: any;
  tarih2: any;
  odemetipleri = [];
  temp: any = {};
  satistoplami: number = 0;

  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "danger",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public navParams: NavParams) {
      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1);
    this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
    this.tarih2 = localISOTime;
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    this.RaporuGetir();

  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  RaporuGetir() {
    var formData = new FormData();
    // formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    // formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    console.log("t1",this.tarih1);
    console.log("t2",this.tarih2);
    formData.append("tarih1", this.tarih1);
    formData.append("tarih2", this.tarih2);
    this.bllOrtak.islem(formData, "KasiyerBazliRapor", "", true).then(a => {
      var sonuc = <any>a;
      this.gelenRapor = sonuc.SonucObject;
      this.satistoplami=0;
      this.gelenRapor.forEach(element=>{
        this.satistoplami+=element.ToplamTutar;
      })
    
       this.gelenRapor.filter(element => {
        this.odemetipleri.push(element.GunSonuKasiyerBazindaDetayListesi);
        
       })
      
      this.closeNav();
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor.ts